import { gql } from '@apollo/client';

export const FETCH_CREW_MEMBER_HOMEBASE = gql`
	query GetCrewMember($id: ID!) {
		getCrewMember(id: $id) {
			currentHomeBase {
				city {
					name
					timezone
				}
			}
		}
	}
`;
